import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';

export default class Projetos {
    
    constructor() {
        this.section = document.querySelector('.single-projeto');
        this.allSliders = this.section.querySelectorAll('.swiper');
        this.btnClose = this.section.querySelector('.btn-close-projeto'); // botão de fechar
        this.ready();
    }

    ready() {
        // inicializa sliders
        if(this.allSliders.length > 0) {
            this.startSlider();
        }

        // inicializa botão de fechar
        if(this.btnClose) {
            this.initCloseButton();
        }
    }

    startSlider() {
        this.allSliders.forEach(slider => {
            const swiper = new Swiper(slider, {
                modules: [Navigation, Pagination],
                slidesPerView: 1,
                grabCursor: true,
                spaceBetween: 0,
                allowTouchMove: true,
                loop: false,
                navigation: {
                    nextEl: slider.querySelector('.slider-button-next'),
                    prevEl: slider.querySelector('.slider-button-prev'),
                },
            });
        });
    }

    initCloseButton() {
        this.btnClose.addEventListener('click', (e) => {
            const hasState = sessionStorage.getItem('stateProjetos');
            if (hasState) {
                e.preventDefault(); // impede o link normal
                history.back();     // volta para a lista exatamente como estava
            }
            // se não tiver estado salvo, segue o link normalmente para /#projetos
        });
    }

}

if (document.querySelector('.single-projeto')) {
    new Projetos();
}
